import { formatAssetDate } from '@modules/consolidator/utils/format-asset-date/format-asset-date'
import { getCorretoraSimple, getNumber, toMoney, formatNumber } from '@utils/Format'
import { decimalLengthPU } from '@utils/Asset'

const TIPOS_RESGATE_TOTAL_SEM_AJUSTE = new Set(['Ação', 'Ações', 'FII'])

/**
 * Formata uma data de ativo em DD/MM/YYYY, ou '-' quando ausente/inválida.
 *
 * Delega ao helper canônico do módulo. A implementação anterior chamava
 * `aawzDate` direto e regredia o fix do #1856: o backend manda as datas do
 * ativo em DD/MM/YYYY, e `aawzDate('15/12/2024')` é inválida (vira '-')
 * enquanto `aawzDate('01/03/2021')` é lida como MM/DD (troca dia e mês em
 * silêncio). O `formatAssetDate` trata o ramo BR antes de cair no parse ISO.
 */
export const formatDataOrDash = (value, addHours) =>
  formatAssetDate(value, addHours)

/**
 * Formatações de exibição aplicadas numa CÓPIA rasa — o objeto recebido pelo
 * bus (linha da tabela da carteira) nunca é mutado; reabrir o modal não
 * re-formata valores já formatados.
 */
export const buildAssetView = (asset) => {
  const view = { ...asset }
  if (!view.data_aplicacao_inicial_f) {
    view.data_aplicacao_inicial_f = formatDataOrDash(view.data_aplicacao_inicial)
  }
  view.data_cotizacao_inicial_f = formatDataOrDash(view.data_cotizacao_inicial)
  // add(3h): datas de vencimento chegam à meia-noite UTC; sem o ajuste o dia
  // regride em GMT-3 (comportamento herdado do modal original)
  view.data_vencimento_f = formatDataOrDash(view.data_vencimento, 3)
  view.pu = toMoney(view.pu) || '-'
  view.preco_medio = toMoney(view.preco_medio) || '-'
  view['Saldo Líquido'] = toMoney(view['Saldo Líquido']) || '-'
  return view
}

const formatMovement = (movement, tipo) => {
  if (movement.resgate_total) {
    movement.operacao = 'Resgate total'
    if (!TIPOS_RESGATE_TOTAL_SEM_AJUSTE.has(tipo)) {
      movement.valor = getNumber(movement.valor) ? movement.valor : '-'
      movement.valor_unitario = getNumber(movement.valor_unitario)
        ? movement.valor_unitario
        : '-'
    }
  }
  if (movement.valor_unitario !== '-') {
    movement.valor_unitario = formatNumber(
      getNumber(movement.valor_unitario),
      decimalLengthPU({ tipo })
    )
  }
  return movement
}

/**
 * Normaliza o response de movements/list/grouped_by/asset: formata cada
 * movimentação, simplifica a corretora e achata `data` no grupo — mesmo
 * tratamento do modal original.
 */
export const mapMovementsResponse = (value) => {
  const mapped = {}
  Object.entries(value).forEach(([key, group]) => {
    const tipoGrupo = (group.data || {}).tipo
    group.movements = (group.movements || []).map((movement) =>
      formatMovement(movement, movement.tipo || tipoGrupo)
    )
    group.data.corretora = getCorretoraSimple(group.data.corretora)
    mapped[key] = { ...group, ...group.data }
  })
  return mapped
}
